import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class CryptoService {

    private secret = "7QBPd4zk5QFTEOVuZJrA1hzY6";
    private key = CryptoJS.SHA256(this.secret);

    constructor() { }

    encrypt(data: any): string {
        const json = JSON.stringify(data);
        const ivBytes = new Uint8Array(16);
        const ivWA = CryptoJS.enc.Hex.parse(
            [...ivBytes]
                .map((b: number) => b.toString(16).padStart(2, "0"))
                .join("")
        );

        const encrypted = CryptoJS.AES.encrypt(json, this.key, {
            iv: ivWA,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const cipherHex = encrypted.ciphertext.toString();
        const cipherBytes = Uint8Array.from(
            cipherHex.match(/.{2}/g)!.map((x: string) => parseInt(x, 16))
        );

        const combined = new Uint8Array(16 + cipherBytes.length);
        combined.set(ivBytes, 0);
        combined.set(cipherBytes, 16);

        return btoa(String.fromCharCode(...combined));
    }

    decrypt(encryptedBase64: any): any {
        try {
            const raw = Uint8Array.from(atob(encryptedBase64), (c: string) => c.charCodeAt(0));

            const ivBytes = raw.slice(0, 16);
            const cipherBytes = raw.slice(16);

            const ivWA = CryptoJS.enc.Hex.parse(
                [...ivBytes]
                    .map((b: number) => b.toString(16).padStart(2, "0"))
                    .join("")
            );

            const cipherWA = CryptoJS.enc.Hex.parse(
                [...cipherBytes]
                    .map((b: number) => b.toString(16).padStart(2, "0"))
                    .join("")
            );

            const decrypted = CryptoJS.AES.decrypt(
                { ciphertext: cipherWA } as any,
                this.key,
                {
                    iv: ivWA,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );

            const json = decrypted.toString(CryptoJS.enc.Utf8);
            if (!json) return null;

            return JSON.parse(json);

        } catch (err) {
            return null;
        }
    }
}
